type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  light?: boolean;
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
  light = false,
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}>
      <span
        className={`font-label text-sm md:text-base tracking-widest ${
          light ? "text-secondary-300" : "text-primary-600"
        }`}
      >
        {eyebrow}
      </span>
      <h2
        className={`mt-2 font-heading text-2xl md:text-4xl font-black text-balance ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      <span
        className={`mt-4 block h-1 w-16 rounded-full ${
          light ? "bg-secondary-400" : "bg-primary-500"
        } ${isCenter ? "mx-auto" : ""}`}
      />
      {desc && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            light ? "text-background-200" : "text-foreground-600"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}